import * as gs from "@ivanlog/gs";
import * as com from "../../plusx-lib/com/tmpls";
import { StatePaged } from "../../plusx-lib/states/abstracts/StatePaged";
import { App } from "../../plusx-lib/App";

export class StateDashboard extends StatePaged<com.PageShareX> {
    static readonly StateName = "dashboard" ;
    private _refreshHandler:gs.HandlerAsync<undefined>;
    constructor() {
        super(com.PageShareX, "ShareX DApp" , true)
        // this.page.ctrls.widgetVXApp.setStatusCmp(this.page.ctrls.widgetVXStatus);

        // (this.page.ctrls.widgetInfoVXS.ctrls.aMain.el as any).href = '/?state=dashboard&vxs=1';
        // (this.page.ctrls.widgetInfoVX.ctrls.aMain.el as any).href = '/';
        // this.page.ctrls.widgetVXSApp.ctrls.btnTabVX.onclick=()=>this._openVX();

        this._refreshHandler = async ()=>{
            await this._refreshAsync();
        }
    }

    public async start() {     
      //  this.gui.showPage(this.page);
       // this._refreshAsync();
        return super.start();
    }


    public async afterStart()
    {
        App.chain.onChangeAccount.addHandler(this._refreshHandler);
//        App.Inst.getInst(LPXInfrastructure).onRefresh.addHandler(this._refreshHandler);

        this.page.ctrls.cmpSharexSaved.initialize();
        this.page.ctrls.cmpWidgetShareXTable.initialize();
        this.page.ctrls.cmpTokens.initialize();

        await super.afterStart();
    }

    public async stop(): Promise<void> {
        App.chain.onChangeAccount.removeHandler(this._refreshHandler);

        this.page.ctrls.cmpSharexSaved.dispose();
        this.page.ctrls.cmpWidgetShareXTable.dispose();
    //    App.Inst.getInst(LPXInfrastructure).onRefresh.removeHandler(this._refreshHandler);
        await super.stop();
    }

    // private async _openVX()
    // {
    //     this.page.ctrls.widgetInfoVXS.show();
    //     this.page.ctrls.widgetInfoVX.hide();
    //     this.page.ctrls.widgetVXApp.show();
    //     this.page.ctrls.widgetVXSApp.hide();
    // }

    // private async _openVXS()
    // {
    //     this.page.ctrls.widgetInfoVXS.hide();
    //     this.page.ctrls.widgetInfoVX.show();
    //     this.page.ctrls.widgetVXApp.hide();
    //     this.page.ctrls.widgetVXSApp.show();
    //     this.page.ctrls.widgetVXSApp.loadAsync();
    // }

    private async _refreshAsync()
    {
        const ctrls = this.page.ctrls;
    //    await ctrls.cmpWidgetLPXTable.refreshAsync(ctrls.cmpWidgetLPXDetails);
    }
}